import http from '../../services/http';
import storage from '../../services/storage';
import { setToken, setUser } from '../auth/authReducer';
import { gitEmails } from '../api/classApi';

import { classInfo, gitClassDetails } from './classApi';
const path1 = 'api/users';
const path2 = 'api/auth';
const path3 = 'api';
const path4 = 'api/teacherassistant';
const path5 = 'api/auth/teacherassistant';

const signinUser = ({ body = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      //showing loader on ui
      const res = await http.post({ url: path2 + '/signin', body });
      const {
        data: { data: user },
        headers,
      } = res;
      const xAuthToken = headers['x-auth-token'];
      dispatch(setToken(xAuthToken));
      dispatch(setUser(user));
      dispatch(
        classInfo({
          onSuccess: (res) => {},
        })
      );
      dispatch(
        gitClassDetails({
          onSuccess: (res) => {},
        })
      );
      setCookie('xAuthToken', xAuthToken, 365);
      storage.store('xAuthToken', xAuthToken);
      storage.store('user', user);
      // //onSuccess event firing
      if (onSuccess) onSuccess(res);
    } catch (err) {
      //onError event firing
      if (onError) onError(err);
      //else handleErrors(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const me = ({ body = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      //showing loader on ui
      const store = getState();
      const res = await http.get({
        url: path1 + '/me',
        headers: {
          // "x-auth-token": token,
          'x-auth-token': store.auth.token,
        },
      });
      storage.store('user', res.data.data);
      storage.store('lastBookId', res.data.data.isBookOpened);
      dispatch(setUser(res.data.data));
      if (onSuccess) onSuccess(res);
    } catch (err) {
      //onError event firing
      if (onError) onError(err);
      //else handleErrors(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const signupUser = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      //showing loader on ui
      const res = await http.post({ url: path1 + '/signup', body });

      //<div>{res}</div>;
      const {
        data: { data: user },
        headers,
      } = res;
      const xAuthToken = headers['x-auth-token'];

      dispatch(setToken(xAuthToken));
      dispatch(setUser(user));
      dispatch(
        classInfo({
          onSuccess: (res) => {},
        })
      );
      dispatch(
        gitClassDetails({
          onSuccess: (res) => {},
        })
      );
      setCookie('xAuthToken', xAuthToken, 365);
      storage.store('xAuthToken', xAuthToken);
      storage.store('user', user);
      if (onSuccess) onSuccess(res);
    } catch (err) {
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

// Teacher Assistant Signup

const teacherAssistantSignup = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      //showing loader on ui
      const res = await http.post({ url: path4 + '/signup', body });

      //<div>{res}</div>;
      const {
        data: { data: user },
        headers,
      } = res;
      const xAuthToken = headers['x-auth-token'];

      dispatch(setToken(xAuthToken));
      dispatch(gitEmails(user));
      /*       dispatch(
              classInfo({
                onSuccess: (res) => {
                 
                },
              })
            );
            dispatch(
              gitClassDetails({
                onSuccess: (res) => {},
              })
            ); */
      setCookie('xAuthToken', xAuthToken, 365);
      storage.store('xAuthToken', xAuthToken);
      storage.store('user', user);
      if (onSuccess) onSuccess(res);
    } catch (err) {
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

// Teacher Assistant SignIn API.

const teacherAssistantSignIn = ({ body = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      //showing loader on ui
      const res = await http.post({ url: path5 + '/signin', body });

      const {
        data: { data: user },
        headers,
      } = res;
      const xAuthToken = headers['x-auth-token'];

      dispatch(setToken(xAuthToken));
      dispatch(setUser(user));
      /*  dispatch(
              classInfo({
                onSuccess: (res) => {
                },
              })
            );
            dispatch(
              gitClassDetails({
                onSuccess: (res) => {},
              })
            ); */
      setCookie('xAuthToken', xAuthToken, 365);
      storage.store('xAuthToken', xAuthToken);
      storage.store('user', user);
      // //onSuccess event firing
      if (onSuccess) onSuccess(res);
    } catch (err) {
      //onError event firing
      if (onError) onError(err);
      //else handleErrors(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const createClassAuth = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const { token } = getState().auth;
      const store = getState();
      const res = await http.post({
        url: path3 + '/class',
        headers: {
          // "x-auth-token": token,
          'x-auth-token': store.auth.token,
        },
        body,
      });

      storage.store('class', res.data.data._id);

      if (onSuccess) onSuccess(res);
    } catch (err) {
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const getUserDetails = ({ userId, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: `${path1}/${userId}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      const {
        data: { data: user },
      } = res;

      dispatch(setUser(user));
      storage.store('user', user);
      if (onSuccess) onSuccess(res);
    } catch (err) {
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export { teacherAssistantSignup, teacherAssistantSignIn, signinUser, signupUser, getUserDetails, createClassAuth, me };

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  if (typeof window !== 'undefined') document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}
